import md5 from "js-md5";
export var signObj = {
  appkey: "aihelp",
  getSign: function(params) {
    if (typeof params == "string") {
      return signObj.paramsStrSort(params);
    } else if (typeof params == "object") {
      var arr = [];
      for (var i in params) {
        if (i == "isMail") {
        }
        if (typeof params[i] === "object") {
          arr.push(i + "=" + JSON.stringify(params[i]));
        } else {
          if (params[i] != undefined) {
            arr.push(i + "=" + params[i]);
          }
        }
      }
      return arr;
    }
  },
  paramsStrSort: function(paramsStr) {
    var url = paramsStr;
    var urlStr = url
      // .split("&")
      .sort()
      .join("&");
    return urlStr;
  },
  /** randomWord 产生任意长度随机字母数字组合
   ** randomFlag-是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
   */
  randomWord: function(randomFlag, min, max) {
    var str = "",
      range = min,
      arr = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ];

    // 随机产生
    if (randomFlag) {
      range = Math.round(Math.random() * (max - min)) + min;
    }
    for (var i = 0; i < range; i++) {
      const pos = Math.round(Math.random() * (arr.length - 1));
      str += arr[pos];
    }
    return str;
  },
  objKeySort: function(arys) {
    //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    var newkey = Object.keys(arys).sort();
    var newObj = {}; //创建一个新的对象，用于存放排好序的键值对
    for (var i = 0; i < newkey.length; i++) {
      //遍历newkey数组
      newObj[newkey[i]] = arys[newkey[i]];
      //向新创建的对象中按照排好的顺序依次增加键值对
    }
    return newObj; //返回排好序的新对象
  },
  returnSign: function(params) {
    var secret = md5(params.appkey + params.timestamp);
    var stringA = signObj.getSign(params);
    stringA = signObj.paramsStrSort(stringA);
    var stringSignTemp = stringA + secret;
    var sign = md5(stringSignTemp);
    return sign;
  }
};
